import React from 'react';
import LogoSpinner from './logo-spinner';

import './preloader.css';

const Preloader = () => (
  <div className="preloader">
    <div className="logo-spinner"><LogoSpinner /></div>
  </div>
);

export default Preloader;



// WEBPACK FOOTER //
// ./src/components/preloader/index.jsx